<template>
  <basic-container>
    <el-tabs type="border-card" @tab-click='tabClick'>
      <el-tab-pane label="回访工单">
        <el-form
          :model="searchForm"
          ref="searchFormRef"
          label-width="80px"
          label-suffix=":"
          v-show="searchBoxFlag"
        >
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="项目名称" prop="projectId">
                <el-select
                  v-model="searchForm.projectId"
                  style="width:100%"
                  placeholder="请选择"
                  @change="projectIdChange"
                >
                  <el-option
                    v-for="item in projectList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="来电类型" prop="projectId">
                <el-select
                  v-model="searchForm.moduleType"
                  style="width:100%"
                  placeholder="来电类型"
                  clearable
                >
                  <el-option
                    v-for="item in moduleTypeList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单编号" prop="projectId">
                <el-input
                  clearable
                  v-model="searchForm.code"
                  placeholder="工单编号"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="项目地点" prop="deptId">
                <el-select
                style="width: 100%;height:32px"
                  clearable
                  @clear="areaClear"
                  :disabled="!areaIdFlag"
                  :value="searchForm.areaName"
                  placeholder="项目地点"
                  
                >
                  <el-option
                    :value="searchForm.areaName"
                    show-all-levels
                    :label="searchForm.areaName"
                  >
                    <el-tree
                      node-key="id"
                      :data="treeFormAreaData"
                      :props="areaTreeProps"
                      :load="areaLazyLoadTree"
                      lazy
                      @node-click="areaNodeTreeClick"
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="报单人" prop="type">
                <el-input
                  clearable
                  v-model="searchForm.requireManName"
                  placeholder="报单人"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="联系方式" prop="type">
                <el-input
                  clearable
                  v-model="searchForm.requireManPhone"
                  placeholder="联系方式"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单评价" prop="type">
                <el-select
                  v-model="searchForm.qualifyFlag"
                  style="width:100%"
                  placeholder="工单评价"
                  clearable
                >
                  <el-option
                    v-for="item in qualifyFlagList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <div style="float:right">
                <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
                  搜索
                </el-button>
                <el-button icon="el-icon-delete" @click="searchClear" size="small">
                  清空
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <avue-crud
          :option="option"
          :table-loading="loading"
          :data="data"
          :page.sync="page"
          ref="crud"
          @on-load="onLoad"
          @current-change="currentChange"
          @size-change="sizeChange"
          @refresh-change="onLoad"
        >
        <template slot="menuRight">
          <searchFromShow
            :searchBoxFlag.sync="searchBoxFlag"
            :removeHeight="searchHeight"
            :option="option"
            :refOption="$refs.crud"
            :reduceShowHeight="161"
            :reduceHeight='49'
          ></searchFromShow>
        </template>
          <template slot-scope="scope" slot="menu">
            <el-button type="text" size="small" icon="el-icon-view" @click="openCourse(scope.row)">
              历 程
            </el-button>
            <el-button type="text" size="small" icon="el-icon-view" @click="openVisit(scope.row)">
              回访
            </el-button>
            <!--<el-button
          type="text"
          size="small"
          icon="el-icon-setting"
          v-if="permissionList.return_visitBtn"
          @click="openReturnVisitDialog(scope.row)">
          回访
        </el-button>-->
          </template>
          <template slot="menuLeft">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              v-if="permission.orderreturnvisitrecord_delete"
              @click="handleDelete"
              >删 除
            </el-button>
          </template>
        </avue-crud>
      </el-tab-pane>
      <el-tab-pane label="回访记录">
         <el-form
          :model="searchRecordForm"
          ref="searchRecordFormRef"
          label-width="80px"
          label-suffix=":"
          v-show="searchBoxFlag"
        >
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="项目名称" prop="projectId">
                <el-select
                  v-model="searchRecordForm.projectId"
                  style="width:100%"
                  placeholder="项目名称"
                  
                >
                  <el-option
                    v-for="item in projectList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="来电类型" prop="projectId">
                <el-select
                  v-model="searchRecordForm.moduleType"
                  style="width:100%"
                  placeholder="来电类型"
                  clearable
                >
                  <el-option
                    v-for="item in moduleTypeList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单编号" prop="code">
                <el-input
                  clearable
                  v-model="searchRecordForm.code"
                  placeholder="工单编号"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="满意度" prop="satisfaction">
                <el-select
                  v-model="searchRecordForm.satisfaction"
                  style="width:100%"
                  placeholder="满意度"
                  clearable
                >
                  <el-option
                    v-for="item in satisfactionList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
           <el-col :span="12">
           <el-form-item label="回访日期">
                     <el-date-picker
                                  style="width: 100%"
                                  clearable
                                  v-model="searchRecordForm.timeRange"
                                  value-format="yyyy-MM-dd"
                                  type="daterange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  >
                              </el-date-picker>
                </el-form-item>
               
        </el-col>
       <el-col :span="6">
              <el-form-item label="工单评价" prop="type">
                <el-select
                  v-model="searchRecordForm.qualifyFlag"
                  style="width:100%"
                  placeholder="工单评价"
                  clearable
                >
                  <el-option
                    v-for="item in qualifyFlagList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <div style="float:right">
                <el-button type="primary" icon="el-icon-search" @click="searchRecord_" size="small">
                  搜索
                </el-button>
                <el-button icon="el-icon-delete" @click="searchClear_" size="small">
                  清空
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <avue-crud
          :option="optionRecord"
          :table-loading="loading"
          :data="dataRecord"
          :page.sync="pageRecord"
          ref="crudRecord"
          @on-load="onLoadRecord"
          @current-change="currentChangeRecord"
          @size-change="sizeChangeRecord"
          @refresh-change="onLoadRecord"
        >
        <template slot="menuRight">
          <searchFromShow
            :searchBoxFlag.sync="searchBoxFlag"
            :removeHeight="searchHeight"
            :option="optionRecord"
            :refOption="$refs.crudRecord"
            :reduceShowHeight="161"
            :reduceHeight='49'
          ></searchFromShow>
        </template>
          <template slot-scope="scope" slot="menu">
            <el-button type="text" size="small" icon="el-icon-view" @click="openVisitedDetail(scope.row)">
              查看
            </el-button>
            <!--<el-button
          type="text"
          size="small"
          icon="el-icon-setting"
          v-if="permissionList.return_visitBtn"
          @click="openReturnVisitDialog(scope.row)">
          回访
        </el-button>-->
          </template>
          <template slot="menuLeft">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              v-if="permission.orderreturnvisitrecord_delete"
              @click="handleDelete"
              >删 除
            </el-button>
          </template>
        </avue-crud>
      </el-tab-pane>
     
    </el-tabs>

    <el-dialog title="回访" :visible.sync="returnVisitShowDialogFlag" :modal-append-to-body="false">
      <div class="el-property-dialog-div">
        <avue-form
          ref="returnVisitFormRef"
          v-model="returnVisitForm"
          :option="returnVisitOption"
          @reset-change="returnVisitReset"
          @submit="returnVisitSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitReturnVisitDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <courseCleanKeeping ref="courseCleanKeeping"></courseCleanKeeping>
    <courseEquipmentInspection ref="courseEquipmentInspection"></courseEquipmentInspection>
    <courseEquipmentMaintenance ref="courseEquipmentMaintenance"></courseEquipmentMaintenance>
    <courseUsecar ref="courseUsecar"></courseUsecar>
    <courseComplaints ref="courseComplaints"></courseComplaints>
    <courseEscort ref="courseEscort"></courseEscort>
    <courseRepair ref="courseRepair"></courseRepair>
    <courseSecurity ref="courseSecurity"></courseSecurity>
    <courseTransport ref="courseTransport"></courseTransport>
    <courseAreaInspection ref="courseAreaInspection"></courseAreaInspection>
     <courseComprehensiveInspection
   
      ref="courseComprehensiveInspection"
      @refresh="onLoad"
    ></courseComprehensiveInspection>



     <hr-dialog title="查看" :allowFull='false' width="60%" :visible.sync="visitRecordVisible">
          <template slot="body">
            <VisitRecord v-if="visitRecordVisible" :row="visitRecordRow" ></VisitRecord>
          </template>
    </hr-dialog>
    <visitForm @handleClose="visitFormHandleClose" ref="visitForm"></visitForm>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  returnVisit,
  returnVisited
} from '@/api/crmedical/order/orderreturnvisitrecord';
import {getDictionary,getBisDictData} from "@/api/common.js";
import { getProjectList } from '@/api/crmedical/project/project';
import { lazyTree } from '@/api/crmedical/project/area';
import { mapGetters } from 'vuex';
import returnVisitOption from './order-returnVisit';
import { lazyAreaTree } from '@/api/crmedical/order/order-list/order-list';
import courseCleanKeeping from './order-list/course-cleanKeeping'; //保洁服务
import courseEquipmentInspection from './order-list/course-equipment-inspection'; //设备巡检
import courseEquipmentMaintenance from './order-list/course-equipment-maintenance'; //设备维保服务
import courseUsecar from './order-list/course-usecar'; //用车服务
import courseComplaints from './order-list/course-complaints'; //投诉监督
import courseEscort from './order-list/course-escort'; //陪护服务
import courseRepair from './order-list/course-repair'; //报修服务
import courseSecurity from './order-list/course-security'; //保安服务
import courseTransport from './order-list/course-transport'; //运送服务
import courseAreaInspection from './order-list/course-area-inspection'; //区域巡检
import searchFromShow from '@/components/search-form-show/index'
import VisitRecord from "./visitRecord.vue"
import visitForm from "./actionForm/visit";
import courseComprehensiveInspection from "./order-list/course-comprehensive-inspection"; //综合巡检
export default {
  components: {
    courseCleanKeeping,
    courseEquipmentInspection,
    courseEquipmentMaintenance,
    courseUsecar,
    courseComplaints,
    courseEscort,
    courseRepair,
    courseSecurity,
    courseTransport,
    courseAreaInspection,
    searchFromShow,
    VisitRecord,
    visitForm,
    courseComprehensiveInspection
  },
  data() {
    return {
      qualifyFlagList:[
        {
          dictKey: 0,
          dictValue: '不合格',
        },
        {
          dictKey: 1,
          dictValue: '合格',
        },
      ],
      visitRecordRow:{},
      visitRecordVisible:false,//回访结果详情查看
      satisfactionList:[],//满意度
      treeFormAreaData: [], //所属区域
      moduleTypeList: [],
      searchBoxFlag: true,
      searchForm: {
        projectId: '',
        moduleType: '',
        code: '',
        areaId: '',
        areaName: '',
        requireManName: '',
        requireManPhone: '',
        qualifyFlag:''
      },
       searchRecordForm: {
        projectId: '',
        moduleType: '',
        code: '',
        areaId: '',
        areaName: '',
        requireManName: '',
        requireManPhone: '',
        timeRange:[],
        timeStart:"",
        timeEnd:'',
        qualifyFlag:''
      },
      areaTreeProps: {
        //标题
        label: 'name',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'name',
      },
      treeProps: {
        //标题
        label: 'name',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'name',
      },
      workStatusList: [], //工单状态

      projectFlag: true,
      projectIdList: [], //项目下拉框
      returnVisitOption: returnVisitOption,
      isReturnVisitDialogFirstOpen: true,
      returnVisitShowDialogFlag: false,
      returnVisitForm: {},
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
       pageRecord: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      reWrite: true,
      selectionList: [],
      temProjectId: '',
      firstDisplayFlag: false,
      option: {
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,

        column: [
           {
            label: '项目名称',
            prop: 'projectName',
            rules: [
              {
                required: false,
                message: '请输入项目名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '工单编号',
            prop: 'code',

            rules: [
              {
                required: true,
                message: '请输入工单编号',
                trigger: 'change',
              },
            ],
          },
         
         
          {
            label: '来电类型',
            prop: 'moduleType',
            type: 'select',

            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=module_type',
            dicData: [],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: false,
                message: '请选择来电类型',
                trigger: 'change',
              },
            ],
          },
           {
            label: '报单人',
            prop: 'requireManName',

            rules: [
              {
                required: false,
                message: '请输入报单人姓名',
                trigger: 'change',
              },
            ],
          },
            {
            label: '联系方式',
            prop: 'requireManPhone',

            rules: [
              {
                required: false,
                message: '请输入报单人联系方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '项目地点',
            prop: 'areaName',
            // search: true,
          },
        
          {
            label:'期望解决时间',
            prop:'expectStartTime'
          },
          {
            label: '完成时间',
            prop: 'endTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: false,
                message: '请输入有效期起',
                trigger: 'change',
              },
            ],
          },
           {
            label: '完成人',
            prop: 'handerName',
           
          },
        

          
          
          
        ],
      },
      optionRecord: {
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,

        column: [
           {
            label: '项目名称',
            prop: 'projectName',
           
          },
          {
            label: '工单编号',
            prop: 'code',

           
          },
         
         
          {
            label: '来电类型',
            prop: 'moduleType',
            type: 'select',

            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=module_type',
            dicData: [],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: false,
                message: '请选择来电类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '报单人',
            prop: 'requireManName',

            rules: [
              {
                required: false,
                message: '请输入报单人姓名',
                trigger: 'change',
              },
            ],
          },
           {
            label: '联系方式',
            prop: 'requireManPhone',

            rules: [
              {
                required: false,
                message: '请输入报单人联系方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '项目地点',
            prop: 'areaName',
            // search: true,
          },
        
          {
            label: '期望解决时间',
            prop: 'endTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd',
            rules: [
              {
                required: false,
                message: '请输入有效期起',
                trigger: 'change',
              },
            ],
          },
          {
            label: '完成时间',
            prop: 'endTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd',
            rules: [
              {
                required: false,
                message: '请输入有效期起',
                trigger: 'change',
              },
            ],
          },
           {
            label: '完成人',
            prop: 'handerName',  
           },
          
           
         

         
        ],
      },
      data: [],
      areaIdFlag: false,
      projectList: [],
      searchHeight:'',
      dataRecord:[],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.orderreturnvisitrecord_add, false),
        viewBtn: this.vaildData(this.permission.orderreturnvisitrecord_view, false),
        delBtn: this.vaildData(this.permission.orderreturnvisitrecord_delete, false),
        editBtn: this.vaildData(this.permission.orderreturnvisitrecord_edit, false),
        return_visitBtn: this.vaildData(this.permission.order_return_visitBtn, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
 watch:{
      '$route.path':function(newVal,oldVal){
         
          if(newVal === '/crmedical/order/orderreturnvisitrecord'){
             this.$refs.crud.$refs.table.doLayout()
             this.$refs.crudRecord.$refs.table.doLayout()
          }
        }
    },
 async created() {
    // this.getDictionary()
    // getProjectList().then((res) => {
    //   this.projectIdList = res.data;
    // });
  await  this.initData();
    this.onLoad();
    this.onLoadRecord()
  },
  mounted() {
    this.calcHeight()
  },
  methods: {
    tabClick(){
      console.log('aaa')
       this.onLoad();
    this.onLoadRecord()
     this.$nextTick(()=>{
        this.$refs.crud.$refs.table.doLayout()
      this.$refs.crudRecord.$refs.table.doLayout()
     })
    },
    areaLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      if(this.searchForm.projectId){
        lazyAreaTree({ parentId: id, projectId: this.searchForm.projectId }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        resolve(data);
      });
      }
    },
    projectIdChange(val){
        this.searchForm.areaName = '';
      this.searchForm.areaId = '';
      this.queryAreaSelect(val);
    },
    visitFormHandleClose(){
      console.log('....')
      this.onLoad()
    },
    openVisit(row){
      this.$refs.visitForm.openDialog(row.id, row.projectId);
    },
    searchClear_(){
      let projectId = this.searchRecordForm.projectId
      this.tool.clearObject(this.searchRecordForm)
      this.searchRecordForm .projectId = projectId
    },
    searchClear(){
       let projectId = this.searchForm.projectId
      this.tool.clearObject(this.searchForm)
      this.searchForm.projectId = projectId
    },
    //获取来电类型
    getOrderModuleTypeList(projectId){
      getDictionary('module_type').then(res=>{
        this.moduleTypeList = res.data
      })
    },
    openVisitedDetail(row){
      this.visitRecordRow = row
      this.visitRecordVisible = true
    },
    getSatisfactionList(){
      getDictionary('return_visit_satisfaction').then(res=>{
        this.satisfactionList = res.data
      })
    },
    calcHeight(){
      this.searchHeight = this.$refs.searchFormRef .$el.clientHeight
      this.option.height = this.bodyHeight -this.searchHeight-420-39;
       this.optionRecord.height = this.bodyHeight -this.searchHeight-420-39;
    },
    queryAreaSelect(value) {
      lazyTree({ parentId: 0, projectId: value }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
            if (item.nodeType === 1) {
              item.disabled = true;
            }
          });
        }
        this.areaIdFlag = true;
        this.treeFormAreaData = data;
      });
    },
    areaClear() {
      this.searchForm.areaName = '';
      this.searchForm.areaId = '';
    },
    areaNodeTreeClick(node) {
      // if (parseInt(node.nodeType) == 1) {
      //   // this.$message.error();
      //   return;
      // }
      let nodeId = node.id;
      let nodeTitle = node.name;
      this.searchForm.areaName = nodeTitle;
      this.searchForm.areaId = nodeId;
    },

    async initData() {
      await getProjectList().then((res) => {
        this.projectList = res.data;
        if (this.projectList.length > 0) {
          this.$set(this.searchForm, 'projectId', this.projectList[0].id);
           this.$set(this.searchRecordForm, 'projectId', this.projectList[0].id); 
          this.queryAreaSelect(this.searchForm.projectId);
        }
      });
      this.getSatisfactionList()
      this.getOrderModuleTypeList()
    },
    searchRecord() {
      this.page.currentPage = 1;
      this.onLoad();
       
    },
    searchRecord_(){
        this.page.currentPage = 1;
          if(this.searchRecordForm.timeRange&&this.searchRecordForm.timeRange.length>0){
                this.searchRecordForm.timeStart = this.dayjs(this.searchRecordForm.timeRange[0]).format('YYYY-MM-DD 00:00:00')
                this.searchRecordForm.timeEnd = this.dayjs(this.searchRecordForm.timeRange[1]).format('YYYY-MM-DD 23:59:59')
            }else{
                this.searchRecordForm.timeRange = []
                this.searchRecordForm.timeStart = ''
                this.searchRecordForm.timeEnd = ''
            }
         this.onLoadRecord();
    },
    // 打开历程弹窗
    openCourse(row) {
      switch (parseInt(row.moduleType)) {
        case 1:
          this.$refs.courseCleanKeeping.getDictionary().then(() => {
            this.$refs.courseCleanKeeping.openDialog(row);
          });
          break;
        case 2:
          this.$refs.courseSecurity.getDictionary().then(() => {
            this.$refs.courseSecurity.openDialog(row);
          });
          break;
        case 3:
          this.$refs.courseEscort.getDictionary().then(() => {
            this.$refs.courseEscort.openDialog(row);
          });
          break;
        case 4:
          this.$refs.courseTransport.getDictionary().then(() => {
            this.$refs.courseTransport.openDialog(row);
          });
          break;
        case 5:
          this.$refs.courseComplaints.getDictionary().then(() => {
            this.$refs.courseComplaints.openDialog(row);
          });
          break;
        case 6:
          this.$refs.courseUsecar.getDictionary().then(() => {
            this.$refs.courseUsecar.openDialog(row);
          });
          break;
        case 7:
          this.$refs.courseRepair.getDictionary().then(() => {
            this.$refs.courseRepair.openDialog(row, false);
          });
          break;
        case 8:
          this.$refs.courseEquipmentMaintenance.getDictionary().then(() => {
            this.$refs.courseEquipmentMaintenance.openDialog(row);
          });
          break;
        case 9:
          this.$refs.courseEquipmentInspection.getDictionary().then(() => {
            this.$refs.courseEquipmentInspection.openDialog(row);
          });
          break;
        case 10:
          this.$refs.courseAreaInspection.getDictionary().then(() => {
            this.$refs.courseAreaInspection.openDialog(row);
          });
           case 11:
            this.$refs.courseComprehensiveInspection.getDictionary().then(() => {
                let obj = Object.assign({},row)
              obj.orderId = row.id
              this.$refs.courseComprehensiveInspection.openDialog(obj);
            });
          break;
          case 12:
          this.$refs.courseRepair.getDictionary().then(() => {
            this.$refs.courseRepair.openDialog(row, false);
          });
          break;
          case 13:
          this.$refs.courseRepair.getDictionary().then(() => {
            this.$refs.courseRepair.openDialog(row, false);
          });
          break;
      }
    },


    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      console.log('d232', this.searchForm.projectId);
      page = page || this.page;
      this.loading = true;
      if (this.searchForm.projectId) {
        console.log('ddd');
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm))
          .then(({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.$refs.crud.$refs.table.doLayout()
             
          })
          .catch((err) => {
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    },
    onLoadRecord(page) {
     
      page = page || this.pageRecord;
      this.loading = true;
      if (this.searchRecordForm.projectId) {
        console.log('ddd');
        returnVisited(Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchRecordForm))
          .then(({ data }) => {
            this.pageRecord.total = data.total;
            this.dataRecord = data.records;
            this.loading = false;
            this.$refs.crudRecord.$refs.table.doLayout()
          })
          .catch((err) => {
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    },
    //打开回访页面
    openReturnVisitDialog(row, flag) {
      if (row.isReturnVisit === 1) {
        console.log(row);
        this.$message.warning('该工单已回访！');
        return;
      }
      this.returnVisitShowDialogFlag = true;

      this.$refs.returnVisitFormRef.resetForm();
      this.returnVisitForm.id = row.id;
      this.returnVisitForm.isReturnVisit = row.isReturnVisit;
      if (flag) {
        return;
      }
    },
    //退出回访页面
    quitReturnVisitDialog(form, done) {
      this.returnVisitShowDialogFlag = false;
      this.$refs.returnVisitFormRef.resetForm();
    },

    //回访数据保存
    returnVisitSubmit(form, done) {
      this.$refs.returnVisitFormRef.validate((valid) => {
        if (valid) {
          //调用回访接口
          returnVisit(form).then(
            () => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.returnVisitShowDialogFlag = false;
              this.$refs.returnVisitFormRef.resetForm();
              done();
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
  },
};
</script>

<style scoped>
 ::v-deep .el-col-6{
   height: 54px;
 }
 ::v-deep .el-col-6 .el-select .el-input__inner{
   height: 32px !important;
 }
 ::v-deep .avue-crud__right{
  display: flex;
}
</style>
